import { useState } from "react";
import { deleteFlowPermanently } from "api/FlowDesignerApis";
import { usePortalFlows } from "hooks/usePortalFlows";
import MenuItem from "@mui/material/MenuItem";
import SoftButton from "components/SoftButton";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import { useFlowUsage } from "hooks/useFlowUsage";
import { DeleteFlowDialog } from "../DeleteFlowDialog";
import { useNavigate } from "react-router-dom";

export const DeleteFlowPermanently = ({ fromActions, callback, item, deleteAvailable }) => {
   const { invitedUsers, getUsage, flowUsage } = useFlowUsage(item);
   const { handleFetchFlows } = usePortalFlows();
   const [showDialog, setShowDialog] = useState(false);
   const { user } = useAuth0();
   const navigate = useNavigate();

   const handleCloseDialog = () => {
      callback?.();
      setShowDialog(false);
   };

   const handleDeletePermanently = async () => {
      const result = await deleteFlowPermanently(user?.stripeId, item.id);

      if (result?.isSuccessful) {
         toast.success("Flow has been permanently deleted");
         handleFetchFlows();
         handleCloseDialog();
      } else {
         toast.error(result?.message || "Flow has not been deleted");
         return;
      }

      if (!fromActions) navigate("/workspace/flows");
   };

   const handleOpenDialog = async () => {
      callback?.();

      await getUsage();

      setShowDialog(true);
   };

   return (
      <>
         {fromActions ? (
            <MenuItem onClick={handleOpenDialog}>Delete Permanently</MenuItem>
         ) : (
            <SoftButton sx={{ backgroundColor: "#E53E3E !important" }} color="error" onClick={handleOpenDialog} disabled={!deleteAvailable}>
               delete forever
            </SoftButton>
         )}
         <DeleteFlowDialog open={showDialog} onAccept={handleDeletePermanently} onClose={handleCloseDialog} flow={item} flowUsage={flowUsage} sharedUsers={invitedUsers} isPermanentDelete />
      </>
   );
};
